import React from 'react';
import ReactDOM from 'react-dom';

import styled from '@emotion/styled';
import { Box } from '@lightspeed/flame/Core';

import AlertMessageDisplay, {
  AlertMessageDTO,
  AlertType,
} from 'root/apps/components/AlertMessageDisplay/AlertMessageDisplay';

export interface PopOutAlertMessageProps {
  message: string | React.ReactElement;
  type: AlertType;
}

const StyledAlertMessageDisplay = styled(AlertMessageDisplay)`
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 1.5rem;
  width: max-content;
  z-index: 1000;
  // lifted from Flame Alert, increased shadow for visibility
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.12), 0 3px 6px 0 rgba(0, 0, 0, 0.06),
    0 1px 2px 0 rgba(0, 0, 0, 0.2);
`;

export const ToasterAlertMessage: React.FC<PopOutAlertMessageProps> = ({ type, message }) => {
  const [dismissed, setDismissed] = React.useState(true);
  const alertMessage: AlertMessageDTO = React.useMemo(
    () => ({
      message: <Box pr={2}>{message}</Box>,
      type,
    }),
    [message, type]
  );

  React.useEffect(() => {
    if (!alertMessage.message && !alertMessage.type) return undefined;
    setDismissed(false);
    const timer = setTimeout(() => {
      setDismissed(true);
    }, 7000); // Dismiss after 7 seconds
    return () => clearTimeout(timer);
  }, [alertMessage]);

  if (message === '') return null;
  if (dismissed) return null;
  const element = document.querySelector('#wrapper');
  if (!element) return null;

  return ReactDOM.createPortal(
    <StyledAlertMessageDisplay
      alertMessage={alertMessage}
      noBorderTop={true}
      data-test="ToasterAlertMessage"
    />,
    element
  );
};
